<template>
  <aha-tab-item :title="$i18nPresenter.t('Notifications')">
    <aha-section>
      <template #header>
        <h5>{{ $i18nPresenter.t('Email preferences') }}</h5>
      </template>
      <template #body>
        <div class="mb-2">
          {{ $i18nPresenter.t('Once in a while, email me about…') }}
        </div>
        <div>
          <aha-checkbox v-model="emailingFeatureUpdates" class="mb-2">
            {{ $i18nPresenter.t('Feature updates and protips') }}
          </aha-checkbox>
        </div>
        <div>
          <aha-checkbox v-model="emailingUsefulContents" class="mb-2">
            {{
              $i18nPresenter.t(
                'General useful content (on new quiz ideas, team building, public speaking, inspiration, and more)')
            }}
          </aha-checkbox>
        </div>
        <div>
          <aha-checkbox v-model="emailingPromotions" class="mb-2">
            {{
              $i18nPresenter.t('Special deals and promotions')
            }}
          </aha-checkbox>
        </div>
        <aha-antd-button
          @click="handleUpdatePreferences"
          :submitting="areEmailPreferencesUpdating"
          v-aha-emit-action
          name="email-preferences-update"
          is-loading-inline
        >
          {{
            $i18nPresenter.t('Update')
          }}
        </aha-antd-button>
      </template>
    </aha-section>
  </aha-tab-item>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import UserApi from '@/api/user'

export default {
  data() {
    return {
      emailingFeatureUpdates: false,
      emailingUsefulContents: false,
      emailingPromotions: false,
      areEmailPreferencesUpdating: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
    this.updatePreferenceStatus()
  },
  methods: {
    async handleUpdatePreferences() {
      const { id: userId } = this.currentUser
      this.areEmailPreferencesUpdating = true
      utils.mixpanelTracking(eventCategories.MY_ACCOUNT, 'Email preferences > Update > Submit')

      try {
        const preferences = {
          emailingPromotions: this.emailingPromotions,
          emailingUsefulContents: this.emailingUsefulContents,
          emailingFeatureUpdates: this.emailingFeatureUpdates,
        }

        await UserApi.patchUserById(userId, { preferences })

        this.currentUser.preferences = preferences
        utils.mixpanelTracking(eventCategories.MY_ACCOUNT, 'Email preferences > Update > Succeeded')
        const successMessage = this.$i18nPresenter.t('Email preferences changed successfully!')
        utils.showToastSuccess(successMessage)
      } catch (error) {
        Sentry.captureException(error)
        this.$emit('hasErrorOnUpdatingUser')
        utils.mixpanelTracking(eventCategories.MY_ACCOUNT, 'Email preferences > Update > Failed')
      }

      this.areEmailPreferencesUpdating = false
    },
    updatePreferenceStatus() {
      const { preferences = {} } = this.currentUser
      this.emailingFeatureUpdates = preferences.emailingFeatureUpdates
      this.emailingUsefulContents = preferences.emailingUsefulContents
      this.emailingPromotions = preferences.emailingPromotions
    },
  },

}
</script>
